import { useContext, useRef, useEffect, useMemo, useState } from 'react';
import { AppContext } from 'Context';
import { ALLOWED_UPLOADS_COUNT, PLANS } from 'Commons';
import useSWR from 'swr';
import Paper from '@mui/material/Paper';
import { axios, dataFetcher, endpoints, baseUrl } from 'Api';
import Table from '@mui/material/Table';
import { ref, get, getDatabase, off, onValue, update } from 'firebase/database';
import { toast } from 'react-toastify';
import Spinner from 'Components/Spinner';
import ListItemText from '@mui/material/ListItemText';
import { v4 as uuid } from 'uuid';
import AWS from 'aws-sdk';
import {
  addS3VideoDraftContent,
  addVideoDraftContent,
  addPhotoContent,
} from 'Api/apiFunctions';
import {
  saveUploadInfo,
  saveUploadDetails,
  saveTitle,
  saveDummy,
  removeDummy,
  removeTitle,
} from 'store/store';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { useSelector, useDispatch } from 'react-redux';
import noImageAvailable from 'Assets/noimage-available.png';
import ForNoImage from 'Assets/Placeholder.png';
import generatingThumbnail from 'Assets/generating-thumbnail.jpg';
import noPhotoAvailable from 'Assets/no-image-available.png';
import CloudUpl from 'Assets/cloud-upload.png';
import OutlinedInput from '@mui/material/OutlinedInput';
import TableHead from '@mui/material/TableHead';
import InputLabel from '@mui/material/InputLabel';
import { ReactComponent as CloseIcon } from 'Assets/close.svg';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import TableRow from '@mui/material/TableRow';
import {
  Checkbox as MuiCheckbox,
  withStyles,
  Typography,
} from '@material-ui/core';
import { Check as CheckIcon } from '@material-ui/icons'; // Import the CheckIcon
import {
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl as MuiFormControl,
  Select as MuiSelect,
  MenuItem as MuiMenuItem,
  InputLabel as MuiInputLabel,
  Tabs,
  Tab,
  TextField,
} from '@mui/material';
import TitleIcon from '@mui/icons-material/Title';
import DescriptionIcon from '@mui/icons-material/Description';
import CategoryIcon from '@mui/icons-material/Category';
import VisibilityIcon from '@mui/icons-material/Visibility';
import RefreshIcon from '@mui/icons-material/Refresh';
import getMyContentsBasedOnUploadDate from '../Api/getMyContentsBasedOnUploadDate';
import { Radio } from './upload-modal/components/Material-reDesign';
import {
  Checkbox,
  StyledCheckbox,
} from '../Pages/private/videos/components/CustomDesigns';
import { GroupSelector } from './group-selector/index';
import {
  awsConfig,
  generateS3Url,
  getBucketName,
  getBucketNamePath,
} from '../Api/awsConfig';
import styles from './Listing.module.css';
import { Pathname } from '../Routes';
import DeleteIcon from '../Assets/delete.png';
import SpinnerImage from '../Assets/Spinner-3.gif';

export default function BulkEdit({
  openEditInBulk,
  setOpenEditInBulk,
  selectedItems,
  setSelectedItems,
  fetchContent
}) {
  // UI State only - no business logic
  const {
    setAppSnackbar,
    s3Data,
    firebaseDatabase,
    setVideoUploadedParts,
    langText,
    userDetails,
    setUploadContainer,
    setIamUploading,
    setdisableDrag,
    setdidIOpenModal,
    subscriptionDetails,
    autoSignIn,
    setSelectedFiles,
    uploadQueue,
    setUploadQueue,
    activeUploads,
    setActiveUploads,
    navigateToInviteFirstTime,
    draftOfUpload,
    setDraftOfUpload,
    MAX_VIDEOS,
    uploadProcessing,
    setUploadProcessing,
    setNavigateOnceClicked,
    setUploadContainer2,
    setAllvideoData,
    defaultCategoryName,
    photoList,
    setPhotoList,
    setCategoryRefreshTrigger,
  } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(false);
  const [applyCategoryDialogOpen, setApplyCategoryDialogOpen] = useState(false);
  const [applyVisibilityDialogOpen, setApplyVisibilityDialogOpen] = useState(false);
  const [selectedCategoryForAll, setSelectedCategoryForAll] = useState('');
  const [selectedVisibilityForAll, setSelectedVisibilityForAll] = useState('2');
  const [addingNewCategory, setAddingNewCategory] = useState({});
  const [creatingCategory, setCreatingCategory] = useState({});
  const [title, setTitle] = useState('');
  const [openGroups, setOpenGroups] = useState([]);
  const [lastSelectedCategory, setLastSelectedCategory] = useState({
    value: '',
    name: '',
  });
  const [findAllVideoCategory, setFindAllVideoCategory] = useState({
    value: '',
    name: defaultCategoryName,
  });

  // State to track edited values for each item by draft_id
  const [editedValues, setEditedValues] = useState({});

  console.log('selectedItems', selectedItems);
  console.log('editedValues', editedValues);
  const [categrory, setCategrory] = useState(undefined);
  const getToken = () => localStorage.getItem('token');
  const videoVisibilityOptions = [
    { name: 'All Viewers', value: '2' },
    { name: 'Only I can view (Private)', value: '1' },
    { name: 'Choose a group', value: '3' },
  ];
  const fetchCategories = async () => {
    try {
      const token = getToken(); // Get the token
      const response = await axios.post(
        `${baseUrl}${endpoints.getMyCategories}`,
        {}, // Empty body for the POST request
        {
          headers: {
            Authorization: `Bearer ${token}`, // Token in Authorization header
          },
        }
      );
      // Check if the response is successful
      if (response?.data?.success) {
        const responseData = response?.data?.data?.map(
          ({ title: name, id: value }) => ({ name, value })
        );
        setCategrory(responseData);
        const allVideosCategory = responseData.find(
          (cat) => cat.name === defaultCategoryName
        );

        if (allVideosCategory) {
          setFindAllVideoCategory({
            name: allVideosCategory?.name,
            value: allVideosCategory?.value,
          });
        }
        if (allVideosCategory && lastSelectedCategory?.value === '') {
          setLastSelectedCategory({
            name: allVideosCategory?.name,
            value: allVideosCategory?.value,
          });
        }

        // Return the categories data for use in handleSubmit
        return responseData;
      }
        console.error('Failed to fetch categories:', response.data.message);
        return [];
    } catch (error) {
      console.error('Error fetching categories:', error);
      return [];
    }
  };
  useEffect(() => {
    fetchCategories();
  }, []);

  // Empty handlers - no functionality
  const handleClose = (event) => {
    event.stopPropagation();
    // UI only - no functionality
  };

  const handleFileChange = () => {
    // UI only - no functionality
  };
  const updateEditedValue = (draftId, field, value) => {
    setEditedValues((prev) => ({
      ...prev,
      [draftId]: {
        ...prev[draftId],
        [field]: value
      }
    }));
  };
  const handleClearAllTitles = () => {
    // Clear all titles in editedValues for all selectedItems
    selectedItems?.forEach((obj) => {
      const draftId = obj?.draft_id;
      if (draftId) {
        updateEditedValue(draftId, 'title', '');
      }
    });
  };

  const handleClearAllDescriptions = () => {
    // Clear all descriptions in editedValues for all selectedItems
    selectedItems?.forEach((obj) => {
      const draftId = obj?.draft_id;
      if (draftId) {
        updateEditedValue(draftId, 'description', '');
      }
    });
  };

  const handleApplyCategoryToAll = () => {
    if (selectedCategoryForAll) {
      // Apply selected category to all items
      selectedItems?.forEach((obj) => {
        const draftId = obj?.draft_id;
        if (draftId) {
          updateEditedValue(draftId, 'categoryId', selectedCategoryForAll);
        }
      });
    }
    setApplyCategoryDialogOpen(false);
  };

  const handleApplyVisibilityToAll = () => {
    // Apply selected visibility to all items
    selectedItems?.forEach((obj, index) => {
      const draftId = obj?.draft_id;
      if (draftId) {
        updateEditedValue(draftId, 'visibility', selectedVisibilityForAll);

        // Handle openGroups state based on visibility
        if (selectedVisibilityForAll === '3') {
          setOpenGroups((prev) => {
            const newOpenGroups = [...prev];
            newOpenGroups[index] = true;
            return newOpenGroups;
          });
        } else {
          setOpenGroups((prev) => {
            const newOpenGroups = [...prev];
            newOpenGroups[index] = false;
            return newOpenGroups;
          });
        }
      }
    });
    setApplyVisibilityDialogOpen(false);
  };

  const handleResetAll = () => {
    // Reset all edited values - clear the editedValues state
    setEditedValues({});

    // Close all group selectors
    setOpenGroups([]);

    // Reset dialog states
    setSelectedCategoryForAll('');
    setSelectedVisibilityForAll('2');
  };

  const handlePublish = async () => {
    setIsLoading(true);

    try {
      // Convert editedValues object to array format
      const data = Object.entries(editedValues).map(([draft_id, changedItems]) => ({
        draft_id,
        ...changedItems
      }));

      const payload = {
        token: getToken(),
        data
      };

      const response = await axios.post(`${baseUrl}/V6/bulkEdit`, payload);

      if (response.data?.success) {
        // Close the bulk edit modal on success
        setOpenEditInBulk(false);

        // Optionally show success message
        setAppSnackbar({
          isVisible: true,
          message: 'Bulk edit completed successfully!',
          type: 'success'
        });
      } else {
        // Show error message
        setAppSnackbar({
          isVisible: true,
          message: response.data?.message || 'Failed to save changes',
          type: 'error'
        });
      }
    } catch (error) {
      console.error('Error publishing bulk edit:', error);
      setAppSnackbar({
        isVisible: true,
        message: 'An error occurred while saving changes',
        type: 'error'
      });
    } finally {
      fetchContent();
      setIsLoading(false);
      setSelectedItems([]);
    }
  };

  const handleDelete = (obj, index) => {
    const draftId = obj?.draft_id;

    // Remove item from editedValues if it exists
    if (editedValues[draftId]) {
      setEditedValues((prev) => {
        const newEditedValues = { ...prev };
        delete newEditedValues[draftId];
        return newEditedValues;
      });
    }

    // Close group selector for this index
    setOpenGroups((prev) => {
      const newOpenGroups = [...prev];
      newOpenGroups[index] = false;
      return newOpenGroups;
    });

    // Note: In a real implementation, you would also remove the item from selectedItems
    // but since selectedItems is a prop, that would need to be handled by the parent component
  };

  const handleSubmit = async (e, index) => {
    e.preventDefault();
    if (!title.trim()) return;

    // Set loading state for this specific index
    setCreatingCategory((prev) => ({
      ...prev,
      [index]: true
    }));

    try {
      const payload = {
        title: title.trim(),
        icon: '1'
      };

      const response = await axios.post(`${baseUrl}${endpoints.addEditCategory}`, payload, {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      });

      if (response.data?.success) {
        // Refresh categories and get the updated list
        const updatedCategories = await fetchCategories();

        // Find the newly created category from the refreshed categories list
        const newCategoryTitle = title.trim();
        const newCategory = updatedCategories?.find((cat) => cat.name === newCategoryTitle);

        // Apply the new category to the current item
        const obj = selectedItems[index];
        if (obj?.draft_id && newCategory?.value) {
          updateEditedValue(obj.draft_id, 'categoryId', newCategory.value);
        }

        // Trigger global category refresh
        setCategoryRefreshTrigger((prev) => prev + 1);

        // Clear form and close
        setTitle('');
        setAddingNewCategory((prev) => ({
          ...prev,
          [index]: false
        }));
      }
    } catch (error) {
      console.error('Error creating category:', error);
    } finally {
      // Clear loading state
      setCreatingCategory((prev) => ({
        ...prev,
        [index]: false
      }));
    }
  };

  const handleInputChange = (e) => {
    setTitle(e.target.value);
  };

  const handleAddNewClick = (index) => {
    setAddingNewCategory((prev) => ({
      ...prev,
      [index]: true,
    }));
  };

  // Helper function to update edited values for a specific draft_id

  // Helper function to get current value (edited value or original value)
  const getCurrentValue = (obj, field) => {
    const draftId = obj?.draft_id;
    if (editedValues[draftId] && editedValues[draftId][field] !== undefined) {
      return editedValues[draftId][field];
    }
    // Return original value based on field type
    switch (field) {
      case 'title':
        return obj?.title || '';
      case 'description':
        return obj?.description || '';
      case 'categoryId':
        return obj?.category_id || '';
      case 'visibility':
        return obj?.visibility || '2';
      case 'group_ids':
        return obj?.group_ids || [];
      default:
        return '';
    }
  };

  const handleTitleChange = (e, obj) => {
    const draftId = obj?.draft_id;
    const newTitle = e.target.value;
    updateEditedValue(draftId, 'title', newTitle);
  };

  const handleDescriptionChange = (e, obj) => {
    const draftId = obj?.draft_id;
    const newDescription = e.target.value;
    updateEditedValue(draftId, 'description', newDescription);
  };

  const handleCategoryChange = (e, obj) => {
    const draftId = obj?.draft_id;
    const newCategoryId = e.target.value;
    updateEditedValue(draftId, 'categoryId', newCategoryId);
  };

  const handleVisibilityChange = (e, obj, index) => {
    const draftId = obj?.draft_id;
    const newVisibility = e.target.value;
    updateEditedValue(draftId, 'visibility', newVisibility);

    // If visibility is set to '3' (Choose a group), open the groups selector for this index
    if (newVisibility === '3') {
      setOpenGroups((prev) => {
        const newOpenGroups = [...prev];
        newOpenGroups[index] = true;
        return newOpenGroups;
      });
    } else {
      // Close groups selector for this index if visibility is not '3'
      setOpenGroups((prev) => {
        const newOpenGroups = [...prev];
        newOpenGroups[index] = false;
        return newOpenGroups;
      });
    }
  };

  const handleMenuItems = () => {
    // UI only - no functionality
  };

  const selectGroup = (groupId, obj) => {
    const draftId = obj?.draft_id;

    // Get current group_ids array from editedValues or original object
    const currentGroupIds = editedValues[draftId]?.group_ids || obj?.group_ids || [];

    // Toggle group selection (add if not present, remove if present)
    let updatedGroupIds;
    if (currentGroupIds.includes(groupId)) {
      // Remove group if already selected
      updatedGroupIds = currentGroupIds.filter((id) => id !== groupId);
    } else {
      // Add group if not selected
      updatedGroupIds = [...currentGroupIds, groupId];
    }

    // Update the editedValues state
    updateEditedValue(draftId, 'group_ids', updatedGroupIds);
  };

  const formatFileSize = (sizeInBytes) => {
    const kilobyte = 1024;
    const megabyte = kilobyte * 1024;
    const gigabyte = megabyte * 1024;
    if (sizeInBytes >= gigabyte) {
      return `${(sizeInBytes / gigabyte).toFixed(2)} GB`;
    }
    if (sizeInBytes >= megabyte) {
      return `${(sizeInBytes / megabyte).toFixed(2)} MB`;
    }
    if (sizeInBytes >= kilobyte) {
      return `${(sizeInBytes / kilobyte).toFixed(2)} KB`;
    }
    return `${sizeInBytes} Bytes`;
  };

  return (
    <div
      className={styles.positioningModel}
      onKeyPress={undefined}
      role="button"
      tabIndex={0}
    >
      <div
        onKeyPress={undefined}
        role="button"
        tabIndex={0}
        onClick={(event) => {
          event.stopPropagation();
        }}
        className={styles.bringCenter}
      >
        <div className={styles.heading}>Edit Video Details</div>
        <div className={styles.headingh3}>
          <span style={{ fontSize: '14px', fontWeight: '600' }}>
            Videos selected
          </span>
        </div>
        <hr className={styles.linex} />

        <div className={styles.overScrollMe}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <div className={styles.TbleCel}>Content Preview</div>
                  </TableCell>
                  <TableCell className={styles.TbleCel}>
                    <div className={styles.TbleCel}>Video Title</div>
                  </TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell className={styles.TbleCel}>
                    <div className={styles.TbleCel}>Category</div>
                  </TableCell>
                  <TableCell className={styles.TbleCel}>
                    <div className={styles.TbleCel}>Visibility</div>
                  </TableCell>
                  <TableCell className={styles.TbleCel}>
                    <div className={styles.TbleCel}>Actions</div>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {selectedItems?.map((obj, i) => (
                  <TableRow
                    key={i}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell>
                      <div className={styles.previewContainer}>
                        <img
                          className={styles.previewImage}
                          src={obj?.thumbnail}
                          alt="Preview"
                        />
                      </div>
                    </TableCell>

                    <TableCell component="th" scope="row">
                      <div className={styles.nameBal}>
                        <input
                          maxLength={70}
                          type="text"
                          value={getCurrentValue(obj, 'title')}
                          placeholder="Title"
                          className={styles.titles}
                          onChange={(e) => handleTitleChange(e, obj)}
                        />
                      </div>
                    </TableCell>

                    <TableCell component="th" scope="row">
                      <div className={styles.nameBal}>
                        <textarea
                          maxLength={500}
                          placeholder="Description"
                          value={getCurrentValue(obj, 'description')}
                          className={styles.description}
                          rows={3}
                          onChange={(e) => handleDescriptionChange(e, obj)}
                        />
                      </div>
                    </TableCell>

                    <TableCell sx={{ width: '233px', textAlign: 'center' }}>
                      {addingNewCategory[i] ? (
                        <form
                          className={styles.addnewForm}
                          onSubmit={(e) => handleSubmit(e, i)}
                        >
                          <button
                            onClick={() => {
                              setTitle('');
                              setAddingNewCategory((prevState) => ({
                                ...prevState,
                                [i]: false,
                              }));
                            }}
                            style={{ background: 'transparent' }}
                          >
                            <CloseIcon />
                          </button>

                          <input
                            type="text"
                            value={title}
                            className={styles.titles}
                            onChange={handleInputChange}
                            placeholder="Enter Category"
                            maxLength={70}
                          />

                          <button
                            style={{
                              opacity: title === '' || creatingCategory[i] ? '0.6' : '1',
                              cursor: title === '' || creatingCategory[i] ? 'not-allowed' : 'pointer',
                            }}
                            disabled={title === '' || creatingCategory[i]}
                            type="submit"
                          >
                            {creatingCategory[i] ? 'Adding...' : 'Add'}
                          </button>
                        </form>
                      ) : (
                        <div className={styles.tabletC}>
                          <button style={{ opacity: '0' }}>
                            <CloseIcon />
                          </button>

                          <FormControl key={i} sx={{ m: 1, width: 120 }}>
                            <InputLabel
                              htmlFor={`category-select-${i}`}
                              color="primary"
                            >
                              Category
                            </InputLabel>
                            <Select
                              value={getCurrentValue(obj, 'categoryId')}
                              onChange={(e) => handleCategoryChange(e, obj)}
                              input={<OutlinedInput label="category" />}
                              displayEmpty
                              inputProps={{ 'aria-label': 'Without label' }}
                            >
                              <MenuItem
                                disableRipple
                                disableTouchRipple
                                onClick={() => handleAddNewClick(i)}
                                sx={{ color: '#5AA5EF', fontWeight: 500 }}
                              >
                                <Typography variant="inherit" noWrap>
                                  Add new
                                </Typography>
                              </MenuItem>
                              {categrory?.map((categoryOption, index) => (
                                <MenuItem
                                  key={index}
                                  value={categoryOption.value || index + 1}
                                >
                                  {categoryOption.name || 'Default Name'}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>

                          <button style={{ opacity: '0' }}>
                            <CloseIcon />
                          </button>
                        </div>
                      )}
                    </TableCell>

                    <TableCell>
                      <div className={styles.visibilityContainer}>
                        <FormControl sx={{ m: 1, width: 252 }}>
                          <Select
                            value={getCurrentValue(obj, 'visibility')}
                            onChange={(e) => handleVisibilityChange(e, obj, i)}
                            inputProps={{ 'aria-label': 'Without label' }}
                          >
                            {videoVisibilityOptions?.map((option, index) => (
                              <MenuItem
                                onClick={() => handleMenuItems(index, i)}
                                key={index}
                                value={option?.value}
                              >
                                {option?.name || 'Default Name'}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>

                        {openGroups[i] && (
                          <div>
                            <GroupSelector
                              onSelect={(groupId) => selectGroup(groupId, obj)}
                              selectedOption={editedValues[obj?.draft_id]?.group_ids || obj?.group_ids || []}
                              setOpenGroups={setOpenGroups}
                              handleMenuItemClick={(index) => {
                                setOpenGroups((prev) => {
                                  const newOpenGroups = [...prev];
                                  newOpenGroups[index] = false;
                                  return newOpenGroups;
                                });
                              }}
                              index={i}
                            />
                          </div>
                        )}
                      </div>
                    </TableCell>

                    <TableCell>
                      <button
                        disabled={isLoading}
                        onClick={() => handleDelete(obj, i)}
                        style={{
                          backgroundColor: 'transparent',
                          cursor: isLoading ? 'default' : 'pointer',
                          opacity: isLoading ? '0.5' : '1',
                        }}
                      >
                        <img
                          src={DeleteIcon}
                          alt="Remove"
                          style={{ height: '25px', width: '25px' }}
                        />
                      </button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>

        <div className={styles.flexico}>
          {/* Tools Section */}
          <div className={styles.toolsSection}>
            <span className={styles.toolsLabel}>Tools</span>
            <div className={styles.toolsDivider} />

            <Tooltip title="Clear all titles">
              <button
                className={styles.toolButton}
                onClick={handleClearAllTitles}
              >
                <TitleIcon className={styles.toolIcon} />
              </button>
            </Tooltip>

            <Tooltip title="Clear all descriptions">
              <button
                className={styles.toolButton}
                onClick={handleClearAllDescriptions}
              >
                <DescriptionIcon className={styles.toolIcon} />
              </button>
            </Tooltip>

            <Tooltip title="Apply same category to all videos">
              <button
                className={styles.toolButton}
                onClick={() => setApplyCategoryDialogOpen(true)}
              >
                <CategoryIcon className={styles.toolIcon} />
              </button>
            </Tooltip>

            <Tooltip title="Apply same visibility to all videos">
              <button
                className={styles.toolButton}
                onClick={() => setApplyVisibilityDialogOpen(true)}
              >
                <VisibilityIcon className={styles.toolIcon} />
              </button>
            </Tooltip>

            <Tooltip title="Reset all to original values">
              <button className={styles.toolButton} onClick={handleResetAll}>
                <RefreshIcon className={styles.toolIcon} />
              </button>
            </Tooltip>
          </div>

          <div className={styles.flexButton}>
            <label htmlFor="file-upload" className={styles.labelButton}>
              Add Videos
            </label>
            <input
              onChange={handleFileChange}
              type="file"
              accept="video/*"
              multiple
              id="file-upload"
              className={styles.hiddenInput}
            />
          </div>

          <div className={styles.flexButtun}>
            <button
              onClick={() => { setOpenEditInBulk(false); setSelectedItems([]); }}
              className={styles.cancel}
            >
              Cancel
            </button>
            <button
              className={styles.save}
              onClick={handlePublish}
              disabled={isLoading}
              style={{
                opacity: isLoading ? 0.6 : 1,
                cursor: isLoading ? 'not-allowed' : 'pointer'
              }}
            >
              {isLoading ? 'Publishing...' : 'Publish'}
            </button>
          </div>
        </div>
      </div>

      {/* Apply Category Dialog */}
      <Dialog
        open={applyCategoryDialogOpen}
        onClose={() => setApplyCategoryDialogOpen(false)}
      >
        <DialogTitle>Apply Category to All Videos</DialogTitle>
        <DialogContent>
          <MuiFormControl fullWidth sx={{ mt: 2 }}>
            <MuiInputLabel>Category</MuiInputLabel>
            <MuiSelect
              value={selectedCategoryForAll}
              onChange={(e) => setSelectedCategoryForAll(e.target.value)}
              label="Category"
            >
              {categrory?.map((cat) => (
                <MuiMenuItem key={cat.value} value={cat.value}>
                  {cat.name}
                </MuiMenuItem>
              ))}
            </MuiSelect>
          </MuiFormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setApplyCategoryDialogOpen(false)}>
            Cancel
          </Button>
          <Button onClick={handleApplyCategoryToAll} variant="contained">
            Apply
          </Button>
        </DialogActions>
      </Dialog>

      {/* Apply Visibility Dialog */}
      <Dialog
        open={applyVisibilityDialogOpen}
        onClose={() => setApplyVisibilityDialogOpen(false)}
      >
        <DialogTitle>Apply Visibility to All Videos</DialogTitle>
        <DialogContent>
          <MuiFormControl fullWidth sx={{ mt: 2 }}>
            <MuiInputLabel>Visibility</MuiInputLabel>
            <MuiSelect
              value={selectedVisibilityForAll}
              onChange={(e) => setSelectedVisibilityForAll(e.target.value)}
              label="Visibility"
            >
              {videoVisibilityOptions
                .filter((option) => option?.value !== '3')
                .map((option) => (
                  <MuiMenuItem key={option.value} value={option.value}>
                    {option.name}
                  </MuiMenuItem>
                ))}
            </MuiSelect>
          </MuiFormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setApplyVisibilityDialogOpen(false)}>
            Cancel
          </Button>
          <Button onClick={handleApplyVisibilityToAll} variant="contained">
            Apply
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
